import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import { PageTrustedBlock } from 'src/common/pageBlocks/PageTrustedBlock/PageTrustedBlock'
import { StoryClientType } from 'src/strapi/types/storiesTypes'

import s from './AboutTrustedBlock.module.scss'

export interface IAboutTrustedBlockProps {
  stories: Array<StoryClientType>
}

export const AboutTrustedBlock: React.FC<IAboutTrustedBlockProps> = ({
  stories,
}) => {
  return (
    <ContentSection>
      <PageTrustedBlock
        stories={stories}
        titleClassName={s.AboutTrustedBlock__title}
      />
    </ContentSection>
  )
}
